
define('text!modules/core/modules/app/states/app/template.html',[],function () { return '<app-sidebar></app-sidebar><app-header></app-header><main class=c-offCanvas--item role=main><div ui-view=body autoscroll></div></main><button class=c-offCanvas--toggle__overlay aria-label="Toggle Navigation" off-canvas-toggle></button><div id=overlay class=c-overlay></div><toaster></toaster>';});

